import React from "react";

const elementDos = () => {
    return(
        <h1>
            ELE 2
        </h1>
    )
}
export default elementDos;